import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.array.find.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import moment from 'moment';
import QMenu from 'quasar/src/components/menu/QMenu.js';;
import DateRange from 'src/components/Pickers/DateRange';
import User from 'src/store/models/User';
export default {
  components: {
    QMenu: QMenu,
    DateRange: DateRange
  },
  props: {
    value: {
      type: String,
      default: 'all'
    },
    dateFrom: {
      default: null
    },
    dateTo: {
      default: null
    },
    rangePickerStartDate: {
      type: String,
      validator: function validator(value) {
        return moment(value).isValid();
      },
      default: function _default() {
        return moment(User.me().account.created_date).subtract(2, 'year').format('YYYY-MM-DD');
      }
    },
    rangePickerEndDate: {
      type: String,
      validator: function validator(value) {
        return moment(value).isValid();
      },
      default: function _default() {
        return moment().add(3, 'months').format('YYYY-MM-DD');
      }
    },
    customizable: {
      // If true, the custom option will be shown and the user will be able to select a custom date range
      type: Boolean,
      default: false
    },
    noTimeframe: {
      // If true, the "All time" option will be shown
      type: Boolean,
      default: false
    },
    navigable: {
      type: Boolean,
      default: false
    },
    allowPastNavigation: {
      type: Boolean,
      default: true
    },
    allowFutureNavigation: {
      type: Boolean,
      default: true
    },
    allowPopup: {
      type: Boolean,
      default: true
    },
    fixedRange: {
      type: Boolean,
      default: false
    },
    confirmable: {
      type: Boolean,
      default: true
    },
    dense: {
      type: Boolean,
      default: false
    },
    outlined: {
      type: Boolean,
      default: false
    },
    rounded: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: ''
    },
    bgColor: {
      type: String,
      default: ''
    },
    labelColor: {
      type: String,
      default: ''
    },
    dark: {
      type: Boolean,
      default: false
    },
    borderless: {
      type: Boolean,
      default: false
    },
    standout: {
      type: Boolean,
      default: false
    },
    minWidth: {
      type: Number,
      default: 120
    },
    firstDayOfWeek: {
      type: Number,
      default: function _default() {
        return parseInt(User.me().settings.weekStart);
      }
    }
  },
  data: function data() {
    var _this = this;

    moment.locale('en', {
      week: {
        dow: this.firstDayOfWeek
      }
    });
    var options = [{
      value: 'today',
      label: this.$t('timeframe.today'),
      date_from: moment().startOf('day').format('YYYY-MM-DD'),
      date_to: moment().endOf('day').format('YYYY-MM-DD')
    }, {
      value: 'yesterday',
      label: this.$t('timeframe.yesterday'),
      date_from: moment().subtract(1, 'days').startOf('day').format('YYYY-MM-DD'),
      date_to: moment().subtract(1, 'days').endOf('day').format('YYYY-MM-DD')
    }, {
      value: 'week_this',
      label: this.$t('timeframe.this_week'),
      date_from: moment().startOf('week').format('YYYY-MM-DD'),
      date_to: moment().endOf('week').format('YYYY-MM-DD')
    }, {
      value: 'month_this',
      label: this.$t('timeframe.this_month'),
      date_from: moment().startOf('month').format('YYYY-MM-DD'),
      date_to: moment().endOf('month').format('YYYY-MM-DD')
    }, {
      value: 'year_this',
      label: this.$t('timeframe.this_year'),
      date_from: moment().startOf('year').format('YYYY-MM-DD'),
      date_to: moment().endOf('year').format('YYYY-MM-DD')
    }, {
      value: 'week_last',
      label: this.$t('timeframe.last_week'),
      date_from: moment().subtract(1, 'weeks').startOf('week').format('YYYY-MM-DD'),
      date_to: moment().subtract(1, 'weeks').endOf('week').format('YYYY-MM-DD')
    }, {
      value: 'month_last',
      label: this.$t('timeframe.last_month'),
      date_from: moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD'),
      date_to: moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD')
    }, {
      value: 'days_7',
      label: this.$t('timeframe.last_7_days'),
      date_from: moment().subtract(6, 'days').startOf('day').format('YYYY-MM-DD'),
      date_to: moment().endOf('day').format('YYYY-MM-DD')
    }, {
      value: 'days_15',
      label: this.$t('timeframe.last_15_days'),
      date_from: moment().subtract(14, 'days').startOf('day').format('YYYY-MM-DD'),
      date_to: moment().endOf('day').format('YYYY-MM-DD')
    }, {
      value: 'days_30',
      label: this.$t('timeframe.last_30_days'),
      date_from: moment().subtract(29, 'days').startOf('day').format('YYYY-MM-DD'),
      date_to: moment().endOf('day').format('YYYY-MM-DD')
    }, {
      value: 'months_3',
      label: this.$t('timeframe.last_3_months'),
      date_from: moment().subtract(3, 'months').add(1, 'day').startOf('day').format('YYYY-MM-DD'),
      date_to: moment().endOf('day').format('YYYY-MM-DD')
    }, {
      value: 'months_6',
      label: this.$t('timeframe.last_6_months'),
      date_from: moment().subtract(6, 'months').add(1, 'day').startOf('day').format('YYYY-MM-DD'),
      date_to: moment().endOf('day').format('YYYY-MM-DD')
    }, {
      value: 'months_12',
      label: this.$t('timeframe.last_12_months'),
      date_from: moment().subtract(12, 'months').add(1, 'day').startOf('day').format('YYYY-MM-DD'),
      date_to: moment().endOf('day').format('YYYY-MM-DD')
    }];

    if (this.noTimeframe) {
      options.push({
        value: 'all',
        label: this.$t('timeframe.all_time'),
        date_from: null,
        date_to: null
      });
    }

    if (this.customizable) {
      options.push({
        value: 'custom',
        label: this.$t('timeframe.custom'),
        date_from: this.dateFrom ? this.dateFrom : moment().startOf('week').format('YYYY-MM-DD'),
        date_to: this.dateTo ? this.dateTo : moment().endOf('week').format('YYYY-MM-DD')
      });
    }

    var current = options.find(function (o) {
      return o.value === _this.value;
    });
    var userDateFormat = User.me().settings.dateFormat.toUpperCase();
    return {
      newValue: this.value,
      datePickerRange: {
        from: current ? current.date_from : this.dateFrom,
        to: current ? current.date_to : this.dateTo
      },
      optionsListHeight: 450,
      customTimeframe: false,
      dismissed: false,
      acceptedDateFormats: ['YYYY-MM-DD', 'YYYY-M-D', 'YYYY-MM-D', 'D-M-YYYY', 'D/M/YYYY', 'D/MM/YYYY', 'DD/MM/YYYY', 'D.M.YYYY', 'D.MM.YYYY', 'DD.MM.YYYY', 'MMM D, YYYY', 'MMM DD, YYYY', 'MMMM D, YYYY', 'MMMM DD, YYYY', userDateFormat],
      options: options
    };
  },
  computed: {
    label: function label() {
      if (this.newValue !== 'custom') {
        return this.selectedOption.label;
      } else {
        return this.humanReadableTimeframeLabel;
      }
    },
    previousRange: function previousRange() {
      var fromIsStartOfMonth = moment(this.datePickerRange.from).isSame(moment(this.datePickerRange.from).startOf('month'), 'day');
      var toIsEndOfMonth = moment(this.datePickerRange.to).isSame(moment(this.datePickerRange.to).endOf('month'), 'day'); // if the period is an entire month, we try to keep the selection smart

      var from, to;

      if (fromIsStartOfMonth && toIsEndOfMonth) {
        // get difference between date_from and date_to of current option in months
        var diff = moment(this.datePickerRange.to).diff(moment(this.datePickerRange.from), 'months');
        from = moment(this.datePickerRange.from).subtract(diff + 1, 'months').startOf('month');
        to = moment(this.datePickerRange.to).subtract(diff + 1, 'months').endOf('month');
      } else {
        // get difference between date_from and date_to of current option in days
        var _diff = moment(this.datePickerRange.to).diff(moment(this.datePickerRange.from), 'days');

        from = moment(this.datePickerRange.from).clone().subtract(_diff + 1, 'days');
        to = moment(this.datePickerRange.to).clone().subtract(_diff + 1, 'days');
      }

      return {
        from: from,
        to: to
      };
    },
    nextRange: function nextRange() {
      var fromIsStartOfMonth = moment(this.datePickerRange.from).isSame(moment(this.datePickerRange.from).startOf('month'), 'day');
      var toIsEndOfMonth = moment(this.datePickerRange.to).isSame(moment(this.datePickerRange.to).endOf('month'), 'day'); // if the period is an entire month, we try to keep the selection smart

      var from, to;

      if (fromIsStartOfMonth && toIsEndOfMonth) {
        // get difference between date_from and date_to of current option in months
        var diff = moment(this.datePickerRange.to).diff(moment(this.datePickerRange.from), 'months');
        from = moment(this.datePickerRange.from).add(diff + 1, 'months').startOf('month');
        to = moment(this.datePickerRange.to).add(diff + 1, 'months').endOf('month');
      } else {
        // get difference between date_from and date_to of current option in days
        var _diff2 = moment(this.datePickerRange.to).diff(moment(this.datePickerRange.from), 'days');

        from = moment(this.datePickerRange.from).clone().add(_diff2 + 1, 'days');
        to = moment(this.datePickerRange.to).clone().add(_diff2 + 1, 'days');
      }

      return {
        from: from,
        to: to
      };
    },
    selectedOption: function selectedOption() {
      var _this2 = this;

      return this.options.find(function (o) {
        return o.value === _this2.newValue;
      });
    },
    humanReadableDateFrom: function humanReadableDateFrom() {
      if (!this.datePickerRange.from) return '';
      return moment(this.datePickerRange.from).format('MMM D, YYYY');
    },
    humanReadableDateTo: function humanReadableDateTo() {
      if (!this.datePickerRange.to) return '';
      return moment(this.datePickerRange.to).format('MMM D, YYYY');
    },
    humanReadableTimeframeLabel: function humanReadableTimeframeLabel() {
      if (this.datePickerRange.from !== this.datePickerRange.to) {
        return "".concat(this.datePickerRange.from ? moment(this.datePickerRange.from).format("MMM D".concat(moment(this.datePickerRange.from).year() !== moment(this.datePickerRange.to).year() ? ', YYYY' : '')) : '', " - ").concat(this.datePickerRange.to ? moment(this.datePickerRange.to).format('MMM D, YYYY') : '');
      } else {
        return moment(this.datePickerRange.from).format('MMM D, YYYY');
      }
    },
    arrowsVisible: function arrowsVisible() {
      return this.customizable && this.newValue !== 'all';
    },
    canSlideBack: function canSlideBack() {
      return this.navigable && (this.allowPastNavigation || moment(this.previousRange.to).isBefore(moment()));
    },
    canSlideForward: function canSlideForward() {
      return this.navigable && (this.allowFutureNavigation || moment(this.nextRange.from).isBefore(moment()));
    },
    textColorClass: function textColorClass() {
      var myClass = {};

      if (this.dark) {
        myClass['text-white'] = true;
      }

      return myClass;
    },
    marginClass: function marginClass() {
      var myClass = {};

      if (!this.label) {
        myClass['q-px-sm'] = true;
      }

      return myClass;
    }
  },
  watch: {
    dateFrom: function dateFrom(val) {
      var _this3 = this;

      this.datePickerRange.from = val;
      var option = this.options.find(function (option) {
        return option.date_from === val && option.date_to === _this3.dateTo;
      });

      if (option) {
        this.newValue = option.value;
      }
    },
    dateTo: function dateTo(val) {
      var _this4 = this;

      this.datePickerRange.to = val;
      var option = this.options.find(function (option) {
        return option.date_to === val && option.date_from === _this4.dateFrom;
      });

      if (option) {
        this.newValue = option.value;
      }
    }
  },
  methods: {
    hideTimeframePicker: function hideTimeframePicker() {
      this.customTimeframe = false;

      if (this.$refs.timeframePicker) {
        this.$refs.timeframePicker.hide();
      }
    },
    checkDate: function checkDate(date) {
      var _this5 = this;

      var isTo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var from = moment(this.datePickerRange.from);
      var to = moment(this.datePickerRange.to);
      var value = this.newValue;
      this.acceptedDateFormats.every(function (format) {
        var myDate = moment(date, format);

        if (myDate.isValid() && myDate.format(format) === date && myDate.isBetween(moment(_this5.rangePickerStartDate).startOf('month'), moment(_this5.rangePickerEndDate).endOf('month'), undefined, '[]')) {
          value = 'custom';

          if (isTo && myDate >= from) {
            to = myDate;
          } else if (!isTo && myDate <= to) {
            from = myDate;
          }

          return false;
        }

        return true;
      });
      this.updateDateRange({
        value: value,
        date_from: from.format('YYYY-MM-DD'),
        date_to: to.format('YYYY-MM-DD')
      });
      this.$forceUpdate();
    },
    updateDateRange: function updateDateRange(option) {
      var _this6 = this;

      var confirmValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      this.newValue = option.value;

      if (option.date_from && option.date_to || this.newValue !== 'custom') {
        this.datePickerRange.from = option.date_from;
        this.datePickerRange.to = option.date_to;
      }

      if (this.newValue === 'custom') {
        this.customTimeframe = true;
      } // keep updated custom option value to use as default when clicked "custom"


      if (this.datePickerRange.from && this.datePickerRange.to) {
        this.updateCustomOption(this.datePickerRange.from, this.datePickerRange.to);
      }

      if (this.$refs.rangePicker) {
        this.$refs.rangePicker.updateLastClickedDate(this.datePickerRange.to);

        if (option.date_from && option.date_to) {
          setTimeout(function () {
            _this6.$refs.rangePicker.bringIntoViewDate(_this6.datePickerRange.to);
          });
        }
      }

      if (confirmValue || !this.confirmable) {
        this.confirmValue();
      }
    },
    updateCustomOption: function updateCustomOption(from, to) {
      // get custom option
      var custom = this.options.find(function (o) {
        return o.value === 'custom';
      });

      if (custom) {
        // update custom option values
        custom.date_from = moment(from).format('YYYY-MM-DD');
        custom.date_to = moment(to).format('YYYY-MM-DD');
      }
    },
    confirmValue: function confirmValue() {
      if (this.dismissed) return;
      this.$emit('input', this.newValue);
      this.$emit('update:dateFrom', this.datePickerRange.from);
      this.$emit('update:dateTo', this.datePickerRange.to);
      this.$emit('frame-changed');
      this.hideTimeframePicker();
    },
    resetValue: function resetValue() {
      this.newValue = this.value;
      this.datePickerRange.from = this.dateFrom;
      this.datePickerRange.to = this.dateTo;
      this.dismissed = true;
      this.hideTimeframePicker();
    },
    onShow: function onShow() {
      this.dismissed = false;
      this.updateOptionsListHeight();
    },
    updateOptionsListHeight: function updateOptionsListHeight() {
      // setTimeout(() => {
      if (this.$refs['options-list']) {
        this.optionsListHeight = this.$refs['options-list'].$el.offsetHeight;
      } // })

    },
    emitEvents: function emitEvents(val) {
      this.$emit('input', this.newValue);
    },
    slideFrameBack: function slideFrameBack() {
      var confirmValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var _this$previousRange = this.previousRange,
          from = _this$previousRange.from,
          to = _this$previousRange.to;
      this.updateDateRange({
        value: 'custom',
        date_from: from.format('YYYY-MM-DD'),
        date_to: to.format('YYYY-MM-DD')
      }, confirmValue);
    },
    slideFrameForward: function slideFrameForward() {
      var confirmValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var _this$nextRange = this.nextRange,
          from = _this$nextRange.from,
          to = _this$nextRange.to;
      this.updateDateRange({
        value: 'custom',
        date_from: from.format('YYYY-MM-DD'),
        date_to: to.format('YYYY-MM-DD')
      }, confirmValue);
    }
  },
  mounted: function mounted() {
    // emit frame changed if time_frame is set
    if (this.value !== 'all') {
      this.emitEvents(this.value, false);
    }
  }
};